module.exports = __webpack_public_path__ + "img/IRIS.a1a56f57.jpeg";